import { render, staticRenderFns } from "./sosPosition.vue?vue&type=template&id=6ed3572c&scoped=true"
import script from "./sosPosition.vue?vue&type=script&lang=js"
export * from "./sosPosition.vue?vue&type=script&lang=js"
import style0 from "./sosPosition.vue?vue&type=style&index=0&id=6ed3572c&prod&lang=css"
import style1 from "./sosPosition.vue?vue&type=style&index=1&id=6ed3572c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed3572c",
  null
  
)

export default component.exports